import React from "react";
import { connect } from "react-redux";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Badge as BadgeUI
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import api from "./../../../Api.js";
import SimpleHeader from "./../../../components/Headers/SimpleHeader.jsx";

class BadgeTypeAdmin extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      badgeTypes: [],
      loading: true,
      showModal: false,
      editing: null,
      form: {
        name: '',
        description: '',
        icon: 'fas fa-award',
        color: '#FFD700',
        category: 'unit_completion',
        requiredScore: 0
      }
    };
  }

  componentDidMount() {
    this.loadBadgeTypes();
  }

  async loadBadgeTypes() {
    try {
      var res = await api.getBadgeTypes();
      this.setState({ badgeTypes: res.data || [], loading: false });
    } catch (err) {
      this.notify('danger', 'Erro', 'Falha ao carregar tipos de badge');
      this.setState({ loading: false });
    }
  }

  notify(type, title, message) {
    try {
      this.refs.notificationAlert.notificationAlert({
        place: 'tr',
        message: (
          <div className="alert-text">
            <span className="alert-title">{title}</span>
            <span> {message}</span>
          </div>
        ),
        type: type,
        icon: type === 'success' ? 'ni ni-check-bold' : 'ni ni-bell-55',
        autoDismiss: 6
      });
    } catch (e) {}
  }

  openCreateModal() {
    this.setState({
      showModal: true,
      editing: null,
      form: {
        name: '',
        description: '',
        icon: 'fas fa-award',
        color: '#FFD700',
        category: 'unit_completion',
        requiredScore: 0
      }
    });
  }

  openEditModal(badgeType) {
    this.setState({
      showModal: true,
      editing: badgeType.id,
      form: {
        name: badgeType.name || '',
        description: badgeType.description || '',
        icon: badgeType.icon || 'fas fa-award',
        color: badgeType.color || '#FFD700',
        category: badgeType.category || 'unit_completion',
        requiredScore: badgeType.requiredScore || 0
      }
    });
  }

  closeModal() {
    this.setState({ showModal: false, editing: null });
  }

  updateForm(field, value) {
    var form = Object.assign({}, this.state.form);
    form[field] = value;
    this.setState({ form: form });
  }

  async saveBadgeType() {
    var form = this.state.form;
    if (!form.name || !form.name.trim()) {
      this.notify('warning', 'Atenção', 'Nome é obrigatório');
      return;
    }

    try {
      var data = {
        name: form.name.trim(),
        description: form.description.trim(),
        icon: form.icon.trim(),
        color: form.color,
        category: form.category,
        requiredScore: parseInt(form.requiredScore) || 0
      };

      if (this.state.editing) {
        await api.updateBadgeType(this.state.editing, data);
        this.notify('success', 'Atualizado', 'Tipo de badge atualizado com sucesso');
      } else {
        await api.createBadgeType(data);
        this.notify('success', 'Criado', 'Tipo de badge criado com sucesso');
      }

      this.closeModal();
      this.loadBadgeTypes();
    } catch (err) {
      this.notify('danger', 'Erro', 'Falha ao salvar: ' + (err.response && err.response.data ? err.response.data : err.message));
    }
  }

  async deleteBadgeType(id, name) {
    if (!window.confirm('Deletar o tipo de badge "' + name + '"? Isso não remove badges já concedidas.')) {
      return;
    }

    try {
      await api.deleteBadgeType(id);
      this.notify('success', 'Removido', 'Tipo de badge deletado');
      this.loadBadgeTypes();
    } catch (err) {
      this.notify('danger', 'Erro', 'Falha ao deletar');
    }
  }

  getCategoryLabel(category) {
    var labels = {
      'unit_completion': 'Conclusão de Unidade',
      'quiz_performance': 'Performance em Quiz',
      'time_dedication': 'Dedicação de Tempo',
      'course_completion': 'Conclusão de Curso',
      'special': 'Especial'
    };
    return labels[category] || category;
  }

  render() {

    var permissions = this.props.permission || [];
    // Permissão 21 = Configurações (só admin)
    if (permissions.indexOf(21) === -1 && permissions.indexOf(26) === -1) {
      return (
        <Container className="mt--7" fluid>
          <Card>
            <CardBody>
              <p className="text-center text-muted">Acesso restrito ao administrador.</p>
            </CardBody>
          </Card>
        </Container>
      );
    }

    var translate = this.props.translate || {};

    return (
      <React.Fragment>
        <div className="rna-wrapper"><NotificationAlert ref="notificationAlert" /></div>
        <SimpleHeader
          name={translate.tipos_de_badge || "Tipos de Badge"}
          way={[{name: translate.gestao_conquistas || "Gestão de Conquistas", url: "/admin/badge-types"}]}
          buttons={<React.Fragment></React.Fragment>}
        />
        <Container className="mt--6" fluid>
          <Row>
            <Col xl="12">
              <Card className="shadow">
                <CardHeader className="d-flex justify-content-between align-items-center border-0">
                  <h3 className="mb-0">
                    <i className="fas fa-award text-warning mr-2" />
                    Gerenciar Tipos de Badge
                  </h3>
                  <Button color="primary" size="sm" onClick={() => this.openCreateModal()}>
                    <i className="fas fa-plus mr-1" />
                    Novo Tipo
                  </Button>
                </CardHeader>
                <CardBody>
                  {this.state.loading ? (
                    <div className="text-center py-4">
                      <i className="fas fa-spinner fa-spin fa-2x text-muted" />
                    </div>
                  ) : this.state.badgeTypes.length === 0 ? (
                    <div className="text-center py-4 text-muted">
                      <i className="fas fa-inbox fa-3x mb-2" style={{ opacity: 0.3 }} />
                      <p>Nenhum tipo de badge cadastrado.</p>
                    </div>
                  ) : (
                    <Table hover responsive>
                      <thead className="thead-light">
                        <tr>
                          <th style={{ width: '60px' }}>Ícone</th>
                          <th>Nome</th>
                          <th>Descrição</th>
                          <th>Categoria</th>
                          <th>Req. Score</th>
                          <th style={{ width: '120px' }}>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.badgeTypes.map((bt) => (
                          <tr key={bt.id}>
                            <td>
                              <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: bt.color + '20',
                                border: '2px solid ' + bt.color,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}>
                                <i className={bt.icon} style={{ color: bt.color, fontSize: '1rem' }} />
                              </div>
                            </td>
                            <td><strong>{bt.name}</strong></td>
                            <td><small className="text-muted">{bt.description}</small></td>
                            <td>
                              <BadgeUI color="info" pill>{this.getCategoryLabel(bt.category)}</BadgeUI>
                            </td>
                            <td>{bt.requiredScore || 0}</td>
                            <td>
                              <Button
                                color="link"
                                size="sm"
                                onClick={() => this.openEditModal(bt)}
                                title="Editar"
                              >
                                <i className="fas fa-edit text-primary" />
                              </Button>
                              <Button
                                color="link"
                                size="sm"
                                onClick={() => this.deleteBadgeType(bt.id, bt.name)}
                                title="Deletar"
                              >
                                <i className="fas fa-trash text-danger" />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* MODAL CRIAR/EDITAR */}
        <Modal isOpen={this.state.showModal} toggle={() => this.closeModal()}>
          <ModalHeader toggle={() => this.closeModal()}>
            {this.state.editing ? 'Editar Tipo de Badge' : 'Novo Tipo de Badge'}
          </ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Nome *</Label>
                <Input
                  type="text"
                  value={this.state.form.name}
                  onChange={(e) => this.updateForm('name', e.target.value)}
                  placeholder="Ex: Mestre do Python"
                />
              </FormGroup>
              <FormGroup>
                <Label>Descrição</Label>
                <Input
                  type="textarea"
                  value={this.state.form.description}
                  onChange={(e) => this.updateForm('description', e.target.value)}
                  placeholder="Descrição visível ao aluno"
                  rows={2}
                />
              </FormGroup>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Ícone (Font Awesome)</Label>
                    <Input
                      type="text"
                      value={this.state.form.icon}
                      onChange={(e) => this.updateForm('icon', e.target.value)}
                      placeholder="fas fa-award"
                    />
                    <small className="text-muted">Ex: fas fa-star, fas fa-trophy</small>
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Cor</Label>
                    <Input
                      type="color"
                      value={this.state.form.color}
                      onChange={(e) => this.updateForm('color', e.target.value)}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Categoria</Label>
                    <Input
                      type="select"
                      value={this.state.form.category}
                      onChange={(e) => this.updateForm('category', e.target.value)}
                    >
                      <option value="unit_completion">Conclusão de Unidade</option>
                      <option value="quiz_performance">Performance em Quiz</option>
                      <option value="time_dedication">Dedicação de Tempo</option>
                      <option value="course_completion">Conclusão de Curso</option>
                      <option value="special">Especial</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Pontuação Mínima</Label>
                    <Input
                      type="number"
                      min="0"
                      max="100"
                      value={this.state.form.requiredScore}
                      onChange={(e) => this.updateForm('requiredScore', e.target.value)}
                    />
                    <small className="text-muted">0 = sem requisito de score</small>
                  </FormGroup>
                </Col>
              </Row>

              {/* Preview */}
              <div className="mt-3 p-3 text-center" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <small className="text-muted d-block mb-2">Preview:</small>
                <div style={{
                  display: 'inline-block',
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  backgroundColor: this.state.form.color + '20',
                  border: '3px solid ' + this.state.form.color,
                  lineHeight: '54px'
                }}>
                  <i className={this.state.form.icon} style={{ color: this.state.form.color, fontSize: '1.4rem' }} />
                </div>
                <p className="mt-2 mb-0">
                  <strong>{this.state.form.name || 'Nome da Badge'}</strong>
                </p>
              </div>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.closeModal()}>Cancelar</Button>
            <Button color="primary" onClick={() => this.saveBadgeType()}>
              {this.state.editing ? 'Atualizar' : 'Criar'}
            </Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  permission: state.permission,
  user: state.user,
  translate: state.translate
}))(BadgeTypeAdmin);
